module.exports = __webpack_public_path__ + "videos/majesty_xl.8d91548.mp4";